import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "By day 4, bedtime went from a 45-minute negotiation to a 15-minute wind-down. I didn't even have to raise my voice. The 'shutdown anchor' is magic.",
    author: 'Jessica',
    context: 'mom of 2',
    accent: 'text-sage',
    bg: 'bg-sage/10'
  }, {
    quote: "I'm a single mom of 3 and the after-school chaos usually breaks me. The 're-entry anchor' gave us a script that actually works. No more yelling over backpacks.",
    author: 'Sarah',
    context: 'single mom of 3',
    accent: 'text-muted-blue',
    bg: 'bg-muted-blue/10'
  }, {
    quote: "I've tried every chart and routine. This is different because it accounts for my bad days. The 'minimum viable' version saved us last Tuesday when I had nothing left.",
    author: 'Elena',
    context: 'tried everything',
    accent: 'text-terracotta',
    bg: 'bg-terracotta/10'
  }];
  return <section className="py-24 px-6 bg-linen" data-id="element-184">
      <div className="max-w-6xl mx-auto" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-186">
          <p className="text-muted-blue font-medium tracking-wide uppercase text-sm mb-4" data-id="element-187">
            Trusted by 500+ solo moms
          </p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal" data-id="element-188">
            Real moms. Real quiet.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-189">
          {testimonials.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl border border-charcoal/5 shadow-sm relative flex flex-col" data-id="element-190">
              <div className={`absolute top-8 right-8 ${item.accent} opacity-20`} data-id="element-191">
                <Quote className="w-8 h-8" data-id="element-192" />
              </div>

              <p className="text-lg text-charcoal/80 font-serif italic mb-8 leading-relaxed relative z-10" data-id="element-193">
                "{item.quote}"
              </p>

              <div className="mt-auto flex items-center gap-4" data-id="element-194">
                <div className={`w-10 h-10 rounded-full ${item.bg} flex items-center justify-center font-serif font-bold ${item.accent}`} data-id="element-195">
                  {item.author[0]}
                </div>
                <div data-id="element-196">
                  <p className="font-bold text-charcoal" data-id="element-197">{item.author}</p>
                  <p className="text-sm text-charcoal/60 uppercase tracking-wide" data-id="element-198">
                    {item.context}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}